import axios from "axios";
import { setHeader, axiosGet, axiosPost,axiosPut } from "../options/header"
//poziv express-u da dohvati podatke vezane uz osobu
export default {
  getCallendar(accessToken,selected_year,selected_month,groupId, selected_type,task_type) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/calendar/"+groupId, {
        params: {
          
          selected_year : selected_year,
          selected_month : selected_month,
          selected_type,
          task_type
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPredmetnaRocista(groupId) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/calendar/case-rocista/"+groupId, {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPersonCalendar(accessToken,selected_year,selected_month,lawyer_id, selected_type, source_type) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/person-calendar/"+lawyer_id, {
        params: {
          
          selected_year : selected_year,
          selected_month : selected_month,
          selected_type,
          source_type
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPersonCalendarList(accessToken,lawyer_id, selected_type, tab_name, start_date, end_date) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/person-calendar/"+lawyer_id+"/list", {
        params: {
          
          selected_type,
          tab_name,
          start_date,
          end_date
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  printCalendar(html_page) {

    try {
      return axios({
        method: 'POST',
        url: process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/person-calendar/print",
        data : {
          html_page : html_page
        },
        responseType:"arraybuffer",
        encodeURI : "UTF-8",
        credentials: true,
        headers: setHeader().headers,
      })
    } catch {
      console.log("Failed to merge documents");
    }
  },
  printVertical(html_page, footer_template) {

    try {
      return axios({
        method: 'POST',
        url: process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/troskovnik/print",
        data : {
          html_page : html_page,
          footer_template: footer_template
        },
        responseType:"arraybuffer",
        encodeURI : "UTF-8",
        credentials: true,
        headers: setHeader().headers,
      })
    } catch {
      console.log("Failed to merge documents");
    }
  },
  printA4(html_page) {

    try {
      return axios({
        method: 'POST',
        url: process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/troskovnik/print-a4",
        data : {
          html_page : html_page
        },
        responseType:"arraybuffer",
        encodeURI : "UTF-8",
        credentials: true,
        headers: setHeader().headers,
      })
    } catch {
      console.log("Failed to merge documents");
    }
  },
  getMiniCallendar(accessToken,selected_year,selected_month,groupId) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/minicalendar/"+groupId, {
        params: {
          
          selected_year : selected_year,
          selected_month : selected_month
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPersonMiniCalendar(accessToken,selected_year,selected_month,lawyer_id) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/person-minicalendar/"+lawyer_id, {
        params: {
          
          selected_year : selected_year,
          selected_month : selected_month
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPersonEvents(accessToken,lawyer_id) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/person-events/"+lawyer_id, {
        params: {
          
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  // getRaspon(accessToken,start_date,end_date,groupId) {
  //   try {
  //     return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/calendar/raspon/"+groupId, {
  //       params: {
          
  //         start_date,
  //         end_date
  //       },
  //        credentials: true
  //     });
  //   } catch {
  //     console.log("Failed attempt at group.");
  //   }
  // },
  addEventToCalendar(formData) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/calendar/",formData, {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  addEventToPersonalCalendar(formData) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/personal-calendar", formData, {
        // params: {
        //   
        //   event : event,
        //   person_uid: id
        // },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  editEvent(formData) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/calendar/",formData, {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  editPersonalEvent(formData) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/personal-calendar",formData, {
        // params: {
        //   
        //   event : event,
        // },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getPersonalAttachment(accessToken,event_id,attachment_id){
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/personal-attachment", {
        params: {
          
          event_id : event_id,
          attachment_id : attachment_id,
        },
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getEventType() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/calendar/event-type", {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getEventBucketStatus() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/calendar/event-bucket-status", {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  editEventBucketStatus(event_id,event_type,status_val) {
    try {
      return axiosPut(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/calendar/event-bucket-status", {
         credentials: true,
        params:{
          event_id:event_id,
          event_type:event_type,
          current_val:status_val,
        }
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getImportanceTypes() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/calendar/event-importance", {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  getSingleEvent(id) {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/calendar/event/"+id, {
         credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
  deleteEvent(accessToken,event) {
    try {
      return axiosPost(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sharepoint/calendar/event-delete", {
         credentials: true,
        params:{
          
          event:event,
        }
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  },
}